import en from './lang/en'
import es from './lang/es'
import fr from './lang/fr'
import de from './lang/de'
import nl from './lang/nl'

export default {
  en,  // English
  es,  // Spanish
  fr,  // French
  de,  // German
  nl,  // Dutch
}
